import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { FONT_LIST } from "../../constant";
import FontListContext from "../../context/FontListContext/FontListContext";
const FontListAddPopup = (props) => {
  const { handleSubmit, simpleValidator, emptyData } = props;
  const { addModel, setAddModel, formData, setFormData, isEdit } =
    useContext(FontListContext);

  const CloseModel = () => {
    emptyData();
    setAddModel(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    <>
      <Modal size="xl" isOpen={addModel} toggle={() => CloseModel()}>
        <ModalHeader toggle={() => CloseModel()}>
          {isEdit ? `${FONT_LIST.EDIT_THEME}` : `${FONT_LIST.ADD_THEME}`}
        </ModalHeader>
        <ModalBody>
          <Container fluid={true} className="p-0">
            <Row>
              <Form className="theme-form" onSubmit={(e) => handleSubmit(e)}>
                <Row>
                  <Col md="6 mb-4">
                    <Label>{"Title *"}</Label>
                    <Input
                      className="form-control"
                      type={"text"}
                      style={{ color: "black" }}
                      name="title"
                      onChange={(e) => handleChange(e)}
                      value={formData?.title}
                      placeholder="Title"
                    />
                    <p style={{ color: "red" }}>
                      {simpleValidator.current.message(
                        "Title",
                        formData?.title,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col md="6 mb-4">
                    <Label>{"Font Family *"}</Label>
                    <Input
                      className="form-control"
                      type={"text"}
                      style={{ color: "black" }}
                      name="fontFamily"
                      onChange={(e) => handleChange(e)}
                      value={formData?.fontFamily}
                      placeholder="Font Family"
                    />
                    <p style={{ color: "red" }}>
                      {simpleValidator.current.message(
                        "Font Family",
                        formData?.fontFamily,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col md="12 mb-4">
                    <Label>{"Google Font Script *"}</Label>
                    <textarea
                      className="form-control"
                      style={{ color: "black" }}
                      name="googleFontScript"
                      rows={5}
                      onChange={(e) => handleChange(e)}
                      value={formData?.googleFontScript}
                      placeholder="Google Font Script"
                    />
                    <p style={{ color: "red" }}>
                      {simpleValidator.current.message(
                        "Google Font Script",
                        formData?.googleFontScript,
                        "required"
                      )}
                    </p>
                  </Col>
                </Row>
                <div className="login-btn mt-2">
                  <Button color="primary" type="submit" value="submit">
                    {"Submit"}
                  </Button>
                </div>
              </Form>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

export default FontListAddPopup;
